import service from "@/utils/request";

export const getOffers = async (page) => {
    try {
        const response = await service.get(`/offers?page=${page}`);
        return response;
    } catch (e) {
        console.error("Failed to fetch offers:", e);
        throw e;
    }
};

export const addOffer = async (offer) => {
    try {
        const response = await service.post('/offers', offer, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (e) {
        console.error("Failed to add offer:", e);
        throw e;
    }
};

export const updateOffer = async (offer) => {
    try {
        const response = await service.post(`/offers/${offer.id}`, offer, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (e) {
        console.error("Failed to update offer:", e);
        throw e;
    }
};

export const deleteOffer = async (data) => {
    try {
        const response = await service.delete(`/offers/${data.id}` , {data});
        return response;
    } catch (e) {
        console.error("Failed to delete offer:", e);
        throw e;
    }
};